import axiosInstance from '../../utils/axiosConfig';

// Action Types
export const GET_ALL_CAUSES = 'GET_ALL_CAUSES';
export const GET_CAUSE_BY_ID = 'GET_CAUSE_BY_ID';
export const CREATE_CAUSE = 'CREATE_CAUSE';
export const UPDATE_CAUSE_BY_ID = 'UPDATE_CAUSE_BY_ID';
export const DELETE_CAUSE_BY_ID = 'DELETE_CAUSE_BY_ID';
export const CREATE_LIST_CAUSE = 'CREATE_LIST_CAUSE';
export const CAUSE_ERROR = 'CAUSE_ERROR';

const API_URL = process.env.REACT_APP_BACKEND_URL_MS_INVESTIGATION;

export const getAllCauses = () => async dispatch => {
    try {
        const res = await axiosInstance.get(`${API_URL}/cause`);
        dispatch({ type: GET_ALL_CAUSES, payload: res.data });
    } catch (err) {
        dispatch({ type: CAUSE_ERROR, payload: err.response.data });
    }
};

export const getCauseById = (id) => async dispatch => {
    try {
        const res = await axiosInstance.get(`${API_URL}/cause/${id}`);
        dispatch({ type: GET_CAUSE_BY_ID, payload: res.data });
    } catch (err) {
        dispatch({ type: CAUSE_ERROR, payload: err.response.data });
    }
};

export const createCause = (causeData) => async dispatch => {
    try {
        const res = await axiosInstance.post(`${API_URL}/cause`, causeData);
        dispatch({ type: CREATE_CAUSE, payload: res.data });
    } catch (err) {
        dispatch({ type: CAUSE_ERROR, payload: err.response.data });
    }
};

export const createListCause = (causesData) => async dispatch => {
    try {
        const res = await axiosInstance.post(`${API_URL}/listCause`, causesData);
        dispatch({ type: CREATE_LIST_CAUSE, payload: res.data });
    } catch (err) {
        dispatch({ type: CAUSE_ERROR, payload: err.response.data });
    }
};

export const updateCauseById = (id, causeData) => async dispatch => {
    try {
        const res = await axiosInstance.put(`${API_URL}/cause/${id}`, causeData);
        dispatch({ type: UPDATE_CAUSE_BY_ID, payload: res.data });
    } catch (err) {
        dispatch({ type: CAUSE_ERROR, payload: err.response.data });
    }
};

export const deleteCauseById = (id) => async dispatch => {
    try {
        await axiosInstance.delete(`${API_URL}/cause/${id}`);
        dispatch({ type: DELETE_CAUSE_BY_ID, payload: id });
    } catch (err) {
        dispatch({ type: CAUSE_ERROR, payload: err.response.data });
    }
};
